import React from 'react'
import { useStyles } from './Styles'
import { Grid } from '@material-ui/core'
import { pointrLogoFull2x } from 'assets/images'

const PointrLogo: React.FC = () => {
  const classes = useStyles({})

  return (
    <Grid item className={classes.root}>
      <img id="pointr-logo" src={pointrLogoFull2x} className={classes.logo} alt={'Pointr'} />
    </Grid>
  )
}

export default PointrLogo
